module.exports = __webpack_public_path__ + "static/img/hinchey-angus.6c47915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinchey-angus.jpg
// module id = wMtE
// module chunks = 0